import { render, staticRenderFns } from "./HelpAccount.vue?vue&type=template&id=286ce914&scoped=true&"
import script from "./HelpAccount.vue?vue&type=script&lang=js&"
export * from "./HelpAccount.vue?vue&type=script&lang=js&"
import style0 from "./HelpAccount.vue?vue&type=style&index=0&id=286ce914&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ce914",
  null
  
)

export default component.exports